import { PageTitle } from '_metronic/layout/core'
import { Outlet, Route, Routes } from 'react-router-dom'
import { BrandManagementContent } from './components/content/BrandManagementContent'

const BrandManagementPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='tema'
          element={
            <>
              <PageTitle>Configurações do tema</PageTitle>
              <BrandManagementContent />
            </>
          }
        />
      </Route>
    </Routes>
  )
}
export default BrandManagementPage
